import React, {useState} from "react";
import {useFormik} from "formik";
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";
import {StyledInput} from "../components/form/input";
import {StyledButton} from "../components/ui-base/button";
import {AuthService} from "../services/auth.service";
import LoginWrapper from "../components/login-wrapper";
import * as Yup from "yup";
import {useTranslation} from "react-i18next";
import logoColor from "../img/logo-color.png";
import {StyledH2, StyledP1} from "../components/ui-base/styles";

const RemindPasswordSchema = Yup.object().shape({
    login: Yup.string().required()
});

const RemindPasswordPage = () => {
    const [emailSent, setEmailSent] = useState(false);
    const { t } = useTranslation('common');

    const remindPassword = useFormik({
        initialValues: {
            login: ''
        },
        validationSchema: RemindPasswordSchema,
        onSubmit: async values => {
            const res = await AuthService.remindPassword(values.login);

            if (res) {
                setEmailSent(true);
            }
        }
    });

    return (
        <LoginWrapper pageType={"other"} children={
            <>
                <StyledGridLogoContainer>
                        <StyledLogo src={logoColor} alt="Logo"/>
                </StyledGridLogoContainer>

                {!emailSent &&
                    <>
                        <StyledGridSmallLoginContainer container direction={"column"}>
                            <StyledH2>{t('remindPassword.resetPass')}</StyledH2>
                        </StyledGridSmallLoginContainer>

                        <StyledGridSmallLoginContainer container direction={"column"} style={{marginTop: '1rem'}}>
                            <form onSubmit={remindPassword.handleSubmit} style={{width: '100%'}}>
                                <Grid container spacing={2} direction="column">
                                    <StyledGridItemWrapper item>
                                        <StyledInput
                                            id="login"
                                            label={t('email')}
                                            placeholder={t('remindPassword.typeEmail')}
                                            onChange={remindPassword.handleChange}
                                            value={remindPassword.values.login}
                                            error={remindPassword.errors.login && remindPassword.touched.login}
                                        />
                                    </StyledGridItemWrapper>

                                    <StyledGridItemWrapper item>
                                        <StyledButton type="submit" color={'primary'}>
                                            {t('remindPassword.saveButton')}
                                        </StyledButton>
                                    </StyledGridItemWrapper>
                                </Grid>
                            </form>
                        </StyledGridSmallLoginContainer>
                    </>
                }

                {emailSent &&
                    <>
                        <StyledGridSmallLoginContainer container direction={"column"}>
                            <StyledH2>{t('remindPassword.emailSentTitle')}</StyledH2>
                            <StyledP1 style={{marginTop: '1rem'}}>{t('remindPassword.emailSentDesc')}</StyledP1>
                        </StyledGridSmallLoginContainer>
                    </>
                }
            </>
        }/>
    );
}

const StyledGridItemWrapper = styled(Grid)`
  width: 100% !important;

  button {
    margin-top: 1rem;
    width: 100%;
  }
`;

const StyledGridLogoContainer = styled(Grid)`
  width: 100%;
  margin: 0 auto 1rem;
`;

const StyledLogo = styled('img')`
  height: 40px;
`;

const StyledGridSmallLoginContainer = styled(Grid)`
  max-width: 500px;
  margin: 0 auto;
`;

export default RemindPasswordPage;
